import React, { Component } from "react"
import Lightbox from 'react-image-lightbox'
import { Link } from "react-router-dom"
import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import { Card, CardBody, Col, Collapse, Label, Media, Row,  Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import ApiRest from "../../ayudas/apiRest"
import { TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes"
import _valid from "../../validations"


export default class SolicitudInformacion extends Component {
    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = {
            idRegistro: props.props,
            registro: _valid(props.datos) && props.datos.registro,
            colapsar: true,
            imgNuevaSolicitudBase64: _valid(props.datos) && props.datos.imgNuevaSolicitudBase64,
            verImagenEnGrande: false,
        };
    }

    componentDidMount() {
        /* NECESITAMOS EL ID DE SOLICITUD O LOS DATOS DE LA SOLICITUD */
        const { idRegistro } = this.state;

        if (_valid(idRegistro)) {
            this.apiRest.getWithFiles('/solicitud/' + idRegistro).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ registro: resultado.data });
                    if (_valid(resultado.imgNuevaSolicitudBase64)) {
                        this.setState({ imgNuevaSolicitudBase64: resultado.imgNuevaSolicitudBase64 })
                    }
                }
            });
        }
    }

    render() {
        const { registro, colapsar, verImagenEnGrande, imgNuevaSolicitudBase64 } = this.state;
        return (
            <div>
                <React.Fragment>
                    <Card>
                        <CardBody>
                            <Link onClick={() => this.setState({ colapsar: !colapsar })} className="text-dark" to="#">
                                <Media className="d-flex align-items-center">
                                    <div className="me-3">
                                        <i className="uil uil-receipt text-primary h2"></i>
                                    </div>
                                    <div className="flex-1 overflow-hidden">
                                        <h5 className="font-size-16 mb-1">Solicitud No. {_valid(registro) ? registro.id : `# ${registro.id}`} </h5>
                                    </div>
                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                </Media>
                            </Link>
                            <hr />
                            {
                                _valid(registro) &&
                                <Collapse isOpen={colapsar}>
                                    <Row>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label
                                                    htmlFor="titulo"
                                                    className="form-label"
                                                >
                                                    Título
                                                </Label>
                                                <p>
                                                    {registro.titulo}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label
                                                    htmlFor="descripcion"
                                                    className="form-label"
                                                >
                                                    Descripción
                                                </Label>
                                                <p>
                                                    {registro.descripcion}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="estado" className="form-label">
                                                    Estado
                                                </Label>
                                                <p>
                                                    {registro.estado_nombre}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="asignado_a_nombre" className="form-label">
                                                    Departamento / Area de Solicitud
                                                </Label>
                                                <p>
                                                    {registro.asignado_a_nombre}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="lugar_ubicacion_nombre" className="form-label">
                                                    Solicitar a (ubicación)
                                                </Label>
                                                <p>
                                                    {registro.lugar_ubicacion_nombre}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="tipo_solicitud_nombre" className="form-label">
                                                    Tipo Solicitud
                                                </Label>
                                                <p>
                                                    {registro.tipo_solicitud_nombre}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="prioridad" className="form-label">
                                                    Prioridad
                                                </Label>
                                                <p>
                                                    {registro.prioridad_nombre}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="fecha_creacion" className="form-label">
                                                    Fecha de Creación
                                                </Label>
                                                <p>
                                                    {registro.fecha_creacion_str}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="fecha_creacion" className="form-label">
                                                    Colaborador que Solicita
                                                </Label>
                                                <p>
                                                    {registro.solicitante_nombre}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                            <Label className="form-label">
                                                Foto
                                            </Label>
                                            <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                {
                                                    _valid(imgNuevaSolicitudBase64) && <img width="100%" src={`data:image/jpeg;base64,${imgNuevaSolicitudBase64}`} alt="solicitud" />
                                                }
                                            </div>
                                        </Col>
                                        {
                                            (registro.cant_rechazos) ? (
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="fecha_creacion" className="form-label">
                                                            Cantidad de Rechazos
                                                        </Label>
                                                        <p>
                                                            {registro.cant_rechazos}
                                                        </p>
                                                    </div>
                                                </Col>
                                                )
                                            : ""
                                        }
                                    </Row>
                                </Collapse>
                            }
                        </CardBody>
                    </Card>
                    <Modal isOpen={verImagenEnGrande} size="lg">
                    <ModalBody>
                        <Row>
                            <img height="100%" width="100%" src={`data:image/jpeg;base64,${imgNuevaSolicitudBase64}`} alt="solicitud" />
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center">
                        < MDBBtn color="danger" onClick={() => this.setState({ verImagenEnGrande: false })}>
                            <MDBIcon icon="fas fa-times" />
                        </ MDBBtn>
                    </ModalFooter>
                </Modal>
                </React.Fragment >
                {/*  { verImagenEnGrande && <Lightbox mainSrc={`data:image/jpeg;base64,${imgNuevaSolicitudBase64}`} onCloseRequest={() => this.setState({ verImagenEnGrande: false })} />} */}
            </div>
        )
    }
}